import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface LicensingPageProps {}

@inject(deps) @observer
export class LicensingPage extends Component<LicensingPageProps> {
  render() {
    return (
      <PageGenericPrismic
        model={this.props.model.page.licensing}
      />
    )
  }
}